import {
    getExecution,
    listExecutions
} from './queries';
import {cancelExecution, executePlaybook} from './mutations';

import {GraphQLQuery,} from '@aws-amplify/api';

import {
    CancelExecution,
    CancelExecutionInput,
    ExecutePlaybook,
    ExecutePlaybookInput,
    GetExecution,
    ListExecutions,
} from "../types.ts";
import {workflowsApiClient} from "../../workflows-api-integration/client.ts";


const client = workflowsApiClient;

export const fetchRecords = async (filter: object) => {
    const response = await client.graphql<GraphQLQuery<ListExecutions>>({
                                                                            query: listExecutions,
                                                                            variables: {
                                                                                filter: filter
                                                                            },
                                                                        });
    return response.data?.listExecutions.items;
};

export const fetch = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<GetExecution>>({
                                                                          query: getExecution,
                                                                          variables: {id: id},
                                                                      });
    return response.data?.getExecution;
};

export const start = async (input: ExecutePlaybookInput) => {
    const response = await client.graphql<GraphQLQuery<ExecutePlaybook>>({
                                                                             query: executePlaybook,
                                                                             variables: {input},
                                                                         });
    return response.data?.executePlaybook;
};

export const cancel = async (input: CancelExecutionInput) => {
    const response = await client.graphql<GraphQLQuery<CancelExecution>>({
                                                                             query: cancelExecution,
                                                                             variables: {input},
                                                                         });
    return response.data?.cancelExecution;
};
